module.exports = __webpack_public_path__ + "img/modulo.03ee52d6.png";